import {FacilityDto} from "../Models";

export interface IFacilityService {
    selectedFacility: FacilityDto;
    activeUserFacilities: FacilityDto[];
}